.confirm { display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.prompt { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--hot); }
@media (max-width: 639px) {
  .confirm { display: flex; width: 100%; }
  .prompt { flex-basis: 100%; }
  .confirm :global(.btn) { flex: 1; }
}
